import { VLayout } from '@sleepstation/components-layouts'
import { baseline, color, themeFontBody } from '@sleepstation/style-api-helpers'
import { getCurrentYear } from '@sleepstation/utils'
import React from 'react'
import styled from 'styled-components'
import site from '../../../../../../const/site'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout)`
  ${color(`bodySecondary`)}
  ${themeFontBody(`normal`)}
  ${baseline(-1)}
  text-align: center;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Smallprint = () => {
  const currentYear = getCurrentYear()

  return (
    <Layout>
      <div>
        {site.copyright}
        {currentYear}
      </div>
    </Layout>
  )
}

export default Smallprint
